import { FEATURES } from '../features'

// Where HUD pieces sit.
//
// Every overlay used to pick its own `bottom-6 left-1/2`, so the moment two of
// them were visible at once they landed on top of each other (the signal bar
// sat right on the status pill). These are the shared slots. If you add
// something to an edge, give it a slot here rather than a one-off offset, and
// check what else can be on screen at the same time.
//
// Bottom centre, from the screen edge upward:
//   statusBottom  the "Pino is ..." pill. Always there, so it owns the floor.
//   signalBottom  the marks strip (R). Sits clear above the pill.
//   hintBottom    the controls hint, above both. Transient, so it stacks.
// Bottom left belongs to the minimap and nothing else — ON DESKTOP.
//
// Right rail, from the top: clock, then the round buttons on a fixed pitch.
// Mobile starts lower because the needs card is taller when it wraps.
//
// ── The phone layout (max-width 767px) is BANDS, top to bottom ──────────
// Measured at 375x812 before this existed: the clock sat ON the needs card,
// and the bottom-left was a three-way pile of minimap + hint + status pill,
// all in the exact corner the walking thumb lands.
//
//   band 1  y12..~64   needs card, full width, compact type (no truncation)
//   band 2  y74        clock LEFT · connect pill + menu button RIGHT
//   band 3  y124       minimap, 92px, top-RIGHT under the menu button;
//                      LEFT, under the clock, the first line folded to
//                      a pill
//   band 4  y224       the first line card (LifeNow), full width. It sat at
//                      y72 before this band existed and covered the connect
//                      pill and the minimap on a 375px phone.
//   omens   y128       centred, below band 2
//   ...the world...
//   feed    bottom 76  chat bubbles, right, max 3, above the pill
//   trip    bottom 74  the mushroom while he is tripping, LEFT, above the
//                      pill's portrait (Sam, 29 Sep). Display only.
//   hint    bottom 68  centred, transient
//   pill    bottom 18  status line, centred, + safe-area inset
//
// The bottom-left is kept clear on phones: that is where the touch stick
// spawns, and chrome there reads as "can I press this" while a thumb is
// trying to walk. The one exception is the trip mushroom, which Sam put
// there, and it takes no touches. If you add a mobile element, take a
// band or make one; do not freelance a corner.
export const hud = {
  statusBottom: 18,
  // The pill's portrait is 46px tall; the mushroom sits 10px above it.
  tripBottomMobile: 74,
  signalBottom: 96,
  // The controls hint went to bottom-left to get out of the pill's way, and
  // then the minimap moved into that corner. Same mistake twice, so it now has
  // a slot of its own rather than a free corner.
  //
  // Where that slot IS depends on whether the marks strip is on. With signals
  // off (which is production) the hint sat at 168 with the pill down at 18,
  // leaving a corridor of empty screen between two things that belong
  // together: how to move, and what he is doing.
  hintBottom: FEATURES.signals ? 168 : 68,

  // Band 4 on phones: the first line card. Minimap bottom (124 + 92) plus
  // the same 8px the bands keep between them. LifeNow's Tailwind class
  // carries the same number; change both.
  nowTopMobile: 224,

  // Round button column. `pitch` is button height + gap.
  railPitch: 52,
  railTopDesktop: 64,
  railTopMobile: 96,
}

/** Top offset for the nth button in the right rail (0-indexed). */
export function railSlot(n) {
  return {
    desktop: hud.railTopDesktop + n * hud.railPitch,
    mobile: hud.railTopMobile + n * hud.railPitch,
  }
}
